<div class="login-container">
  <mat-card class="login-card">
    <mat-card-header>
      <mat-card-title>Willkommen zurück!</mat-card-title>
      <mat-card-subtitle>Melde dich an, um fortzufahren</mat-card-subtitle>
    </mat-card-header>

    <mat-card-content>
      <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
        <mat-form-field appearance="outline">
          <mat-label>Benutzername</mat-label>
          <mat-icon matPrefix>person</mat-icon>
          <input matInput formControlName="username" required />
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Passwort</mat-label>
          <mat-icon matPrefix>lock</mat-icon>
          <input matInput formControlName="password" [type]="hidePassword ? 'password' : 'text'" required />
          <button mat-icon-button matSuffix (click)="hidePassword = !hidePassword" type="button">
            <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
          </button>
        </mat-form-field>

        <div class="form-actions">
          <a routerLink="/forgot-password" class="forgot-password-link">Passwort vergessen?</a>
          <button mat-flat-button type="submit" color="accent" [disabled]="loginForm.invalid"> Anmelden </button>
        </div>
      </form>
    </mat-card-content>

    <mat-card-footer>
      <p>Noch kein Konto? <a routerLink="/register" class="forgot-password-link">Jetzt registrieren</a></p>
    </mat-card-footer>
  </mat-card>
</div>
